<template>
    <div>
        <div style="display: flex; align-items: center; padding: 24px; border: 1px solid #ededed;">
            <HeadImg :images="userForm.headImg" />
            <div style="margin-left: 24px;">
                <p>昵称：{{ userForm.nickName }}<span style="color: red; margin-left: 8px;">{{ userForm.sex == 1?'男':userForm.sex == 2?'女':''}}</span> </p>
                <p>UID：{{ userForm.uid }}</p>
                <p>生日：{{ userForm.sysBirthday }}</p>
                <get-plain-dialog title="手机：" :code="userForm.phone" :uid="userForm.uid" :type="9" :subType="0"/>
            </div>
        </div>
        <div style="text-align:center; margin-top: 24px;">
            <el-button @click.native="cancel">返回</el-button>
            <el-button type="primary" @click.native="submit">新建</el-button>
        </div>
    </div>
</template>

<script>
    import HeadImg from "../../../components/HeadImg";
    import Dialog from '@/assets/js/dialog'
    import GetPlainDialog from "@/components/resume/GetPlainDialog";
    import InfoImgDialog from "./InfoImgDialog";
    export default {
        components: { HeadImg, GetPlainDialog },
        props: {
            value: Object
        },
        data() {
            return {
                userForm: this.value.userForm,
            }
        },
        methods: {
            cancel() {
                this.$emit('close')
            },

            submit() {
                Dialog.open({
                    title: '创建信息',
                    component: InfoImgDialog,
                    data: {
                        userForm: this.userForm,
                        infoImgForm: {userId: 0, id: 0},
                        idx: -2,
                    },
                    confirm: (result) => {
                        this.$emit('confirm');
                    }
                })
            }
        }
    }
</script>

<style>

</style>
